import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'eventq-event-meta-bar',
  templateUrl: './event-meta-bar.html',
  styleUrl: './event-meta-bar.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventqEventMetaBar {
  readonly title = input.required<string>();
  readonly eventId = input.required<string>();
  readonly address = input.required<string>();
  readonly currentTime = input.required<string>();
}
